// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});
$w.onReady( () => {
  $w("#dataset1").onReady( () => {

    $w("#repeater2").onItemReady( ($item, itemData, index) => {
      let theItem = itemData.title;
      var shortDescription = theItem.substr(0,50);
      $item("#text108").text = shortDescription + " ... ";
    });

  } );
  
} );